import "./loader.scss";
import React from "react";

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-container__loader"></div>
    </div>
  );
}

export default Loader;
